var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:{black: _vm.isBlack}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copy"},[_c('i18n',{attrs:{"path":"hf.copy"}},[_c('br',{attrs:{"place":"break"}})])],1),_c('app-header',{class:{black: _vm.isBlack}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }